import React from 'react';
import i18n from '../../i18n/i18n.js';
import PageHeader from "../../components/PageHeader/PageHeader.js";
import { Utils } from '../../Utils';
import { ModalsContext, withAppContext } from '../../contexts/AppContext';
import SlideInContent from '../AnimatedElements/SlideInContent.js';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';

import './Shops.css'; 

class Shops extends React.Component {

  static contextType = ModalsContext;

  animationObjectRef = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      shops: [],
      show: false,
    };
    
    this.pendingHide = false;
  }

  show() {
    const { show } = this.state;

    if (show) {
      this.hide();
      return;
    }

    Utils.get_server_data(
      '',
      {
        ajax_event:'shops',
        APICACHE:'false'
      }, 
      {
        ajax_event: 'shops',
        formData: JSON.stringify({}),
      }
    )
    .then((res)=>{
      this.setState({shops: res.shops, show: true}, () => {
        setTimeout(() => this.animationObjectRef.current?.setVisible(true), 0);
      });
    });
  }

  hide() {
    if (!this.state.show) {
      this.pendingHide = false;
      return;
    }

    this.pendingHide = true;
    this.animationObjectRef.current?.setVisible(false);
  }

  handleSlideOutComplete = () => {
    if (this.pendingHide) {
      this.pendingHide = false;
      this.setState({show: false});
      this.context.AppFooterMenuRef?.current?.set_item_inactive_by_name('shops');
    }
  }

  toggle() {
    if (this.state.show)
    {
      this.hide();
    }
    else {
      this.show();
    }
  }

  toggle_div_open(shop_id) {
    const { shops } = this.state;
    const clickedId = parseInt(shop_id);

    const updatedShops = shops.map((shop) => {
      const isClickedShop = parseInt(shop.id) === clickedId;
      const isCurrentlyOpen = parseInt(shop.div_open) === 1;

      return {
        ...shop,
        div_open: isClickedShop ? (isCurrentlyOpen ? 0 : 1) : 0,
      };
    });

    this.setState({shops: updatedShops});
  }

  handleNavigate = (lat, lng) => {
    // Google Maps navigation URL - univerzális minden platformon
    const url = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
    window.open(url, '_blank');
  }

  getMapCenter() {
    const { shops } = this.state;
    
    if (!shops || shops.length === 0) {
      return { lat: 47.4979, lng: 19.0402 }; // Budapest alapértelmezett
    }

    // Számoljuk ki az átlagos koordinátákat
    let totalLat = 0;
    let totalLng = 0;
    let validCount = 0;

    shops.forEach(shop => {
      const lat = parseFloat(shop.gps_lat);
      const lng = parseFloat(shop.gps_long);
      
      if (!isNaN(lat) && !isNaN(lng)) {
        totalLat += lat;
        totalLng += lng;
        validCount++;
      }
    });

    if (validCount === 0) {
      return { lat: 47.4979, lng: 19.0402 };
    }

    return {
      lat: totalLat / validCount,
      lng: totalLng / validCount
    };
  }

  render() {

    const { show, shops } = this.state;

    if (!show) return null;

    const mapCenter = this.getMapCenter();
    const mapContainerStyle = {
      width: '100%',
      height: '300px'
    };

    const shopMapContainerStyle = {
      width: '100%',
      height: '200px',
      marginBottom: '15px'
    };

    const renderMap = () => (
      
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        center={mapCenter}
        zoom={shops.length === 1 ? 15 : 7}
      >
        {shops.map((shop) => {
          const lat = parseFloat(shop.gps_lat);
          const lng = parseFloat(shop.gps_long);
          
          if (!isNaN(lat) && !isNaN(lng)) {
            return (
              <Marker
                key={`marker_${shop.id}`}
                position={{ lat, lng }}
                title={shop.label}
                icon={{
                  url: '/assets/images/marker.png',
                  scaledSize: { width: 22, height: 22 }
                }}
                onClick={() => this.toggle_div_open(shop.id)}
              />
            );
          }
          return null;
        })}
      </GoogleMap>
    );

    const renderShopMap = (shop) => {
      const lat = parseFloat(shop.gps_lat);
      const lng = parseFloat(shop.gps_long);
      
      if (isNaN(lat) || isNaN(lng)) {
        return null;
      }

      return (
        <div className="shop_map_container">
          {window.google && window.google.maps ? (
            <>
              <GoogleMap
                mapContainerStyle={shopMapContainerStyle}
                center={{ lat, lng }}
                zoom={16}
              >
                <Marker
                  position={{ lat, lng }}
                  title={shop.label}
                  icon={{
                    url: '/assets/images/marker.png',
                    scaledSize: { width: 30, height: 30 }
                  }}
                />
              </GoogleMap>
              <button 
                className="navigate_button" 
                onClick={() => this.handleNavigate(lat, lng)}
              >
                Navigálj ide
              </button>
            </>
          ) : null}
        </div>
      );
    };

    return (
      <SlideInContent 
        key={'slide_in_shops'} 
        ref={this.animationObjectRef} 
        className={'container floating_container page_shops'}
        useAnimation={true}
        onHidden={this.handleSlideOutComplete}
      >
        <div className="content">
          
          <PageHeader parent_ref={this} title={i18n.t('shopsTitle')} />
          <div className='container_inner'>

          {this.props.appContext?.appRef?.current?.apiKeys?.google_maps_api_key && (
            <div className="map_container">
              {window.google && window.google.maps ? (
                renderMap()
              ) : (
                <LoadScript 
                  googleMapsApiKey={this.props.appContext.appRef.current.apiKeys.google_maps_api_key}
                  loadingElement={<div>Térkép betöltése...</div>}
                  preventGoogleFontsLoading={true}
                >
                  {renderMap()}
                </LoadScript>
              )}
            </div>
          )}
          
            {!!shops ? 
              shops.map((shop) => {
                return <div key={`shop_${shop.id}`} className={`shop ${parseInt(shop.div_open) === 1 ? 'open' : ''}`}>
                  <h3 onClick={(e) => this.toggle_div_open(shop.id)}>{shop.label}<span className="toggler">{parseInt(shop.div_open) === 1 ? '-' : '+'}</span></h3>
                  <div className="details">
                    {parseInt(shop.div_open) === 1 && this.props.appContext?.appRef?.current?.apiKeys?.google_maps_api_key && renderShopMap(shop)}
                    <div className="address">{shop.address}</div>
                    {shop.phone && (
                      <div className="address">
                        <label>{i18n.t('shopsPhone')}</label>
                        <span>
                          <a
                            href={`tel:${String(shop.phone).replace(/[^+\d]/g, '')}`}
                          >{shop.phone}</a>
                        </span>
                      </div>
                    )}
                    {shop.email && (
                      <div className="address">
                        <label>{i18n.t('shopsEmail')}</label>
                        <span>
                          <a
                            href={`mailto:${String(shop.email).trim()}`}
                          >{shop.email}</a>
                        </span>
                      </div>
                    )}
                    {shop.description && <div className='description'>{shop.description}</div>}
                    <div className="opening">
                      <label>{i18n.t('shopsOpening')}</label>
                      <span dangerouslySetInnerHTML={{__html: shop.opening}}></span>
                    </div>
                    {shop.image ? <div className="image">
                      <img
                        src={`${process.env.REACT_APP_ORIGINAL_SHOP_URL}/upload_files/shops/${shop.image}`}
                        alt={shop.label || i18n.t('shopsTitle')}
                      />
                    </div> : ''}

                    {shop.promotional_brochure && shop.promotional_brochure_image ? (
                      <div className="promo-brochure">
                        <div className="promo-brochure__header">
                          <span className="promo-brochure__title">{shop.promotional_brochure_name || i18n.t('shopsPromoBrochure')}</span>
                          {(shop.promotional_brochure_start_time || shop.promotional_brochure_end_time) && (
                            <span className="promo-brochure__validity">
                              {i18n.t('shopsPromoValidity')}
                              {shop.promotional_brochure_start_time && parseInt(shop.promotional_brochure_start_time) !== 0
                                ? ' ' + new Date(parseInt(shop.promotional_brochure_start_time) * 1000).toLocaleDateString()
                                : ''}
                              {shop.promotional_brochure_start_time && shop.promotional_brochure_end_time ? ' – ' : ''}
                              {shop.promotional_brochure_end_time && parseInt(shop.promotional_brochure_end_time) !== 0
                                ? new Date(parseInt(shop.promotional_brochure_end_time) * 1000).toLocaleDateString()
                                : ''}
                            </span>
                          )}
                        </div>
                        <a className="promo-brochure__link" href={shop.promotional_brochure} target="_blank" rel="noopener noreferrer">
                          <img className="promo-brochure__image" src={shop.promotional_brochure_image} alt={shop.promotional_brochure_name || i18n.t('shopsPromoBrochure')} />
                          <span className="promo-brochure__btn">{i18n.t('shopsPromoBrochureOpen')}</span>
                        </a>
                      </div>
                    ) : ''}

                  </div>
                </div>
              })
            : ''}
          </div>

        </div>
      </SlideInContent>
    );
  }
}

export default withAppContext(Shops);